import exclusiveInterfaces from './interface'

// for development use
const useDummyInterfaces = false;

const interfaces = useDummyInterfaces
  ? require('mocks/voucher/public').default
  : window.API.wrap(exclusiveInterfaces, 'xhrVoucherPublic');

export default interfaces
